import { Navigate } from 'react-router';

import { useCurrentUser } from '@chartai/api-client';

import { LoadingSpinner } from '@/shared/components/feedback/LoadingSpinner';

interface PublicGuardProps {
  children: React.ReactNode;
}

export function PublicGuard({ children }: PublicGuardProps) {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return <LoadingSpinner size="lg" className="min-h-screen" />;
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
